import React from 'react';
import { ErrorNotice } from './DashboardCommon';

interface DashboardLayoutProps {
  title: string;
  error: string | null;
  onDismissError: () => void;
  tableSection: React.ReactNode;
  pagination: React.ReactNode;
  filterSidebar: React.ReactNode;
  headingActions?: React.ReactNode;
  children?: React.ReactNode;
}

/**
 * Shared page shell for kit dashboards to keep structure DRY.
 */
const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  title,
  error,
  onDismissError,
  tableSection,
  pagination,
  filterSidebar,
  headingActions,
  children,
}) => {
  return (
    <div className="provider-dashboard">
      <ErrorNotice error={error} onDismiss={onDismissError} />

      <div className="dashboard-main">
        <div className="dashboard-content">
          <div className="search-filter-section">
            <h3>{title}</h3>
            {headingActions}
          </div>

          {tableSection}

          {pagination}
        </div>

        {filterSidebar}
      </div>

      {children}
    </div>
  );
};

export default DashboardLayout;

